<template>
  <onboardingModal :step="1">
    <template slot="body">
      <b-form
        novalidate
        ref="form"
        :validated="formValidated"
      >
        <b-row class="no-gutters">

          <b-col v-for="(input, key) in fields.user" :md="input.columns" :key="key" class="px-3">
            <b-input-group class="position-relative">
              <b-input
                v-model="params[input.name]"
                class="w-100 mb-4 rounded"
                :type="input.type"
                :placeholder="input.required ?
                  input.placeholder + $t('form.required_star') :
                  input.placeholder"
                :required="input.required">
              </b-input>
              <div class="invalid-feedback position-absolute mt-0 text-left" style="bottom: 6px">
                {{$t('errors.error_validation')}}
              </div>
            </b-input-group>
          </b-col>

          <b-col class="bg-light px-3 rounded mb-4" md="12"
                 v-for="(resource, index) in params.resources"
                 :key="`resource-${index}`">
            <p class="text-muted small mb-0 mt-3">{{$t('onboarding.url_validation')}}</p>
            <b-input-group class="position-relative mb-3">
              <b-input
                v-for="(input, key) in fields.resource"
                :key="key"
                v-model="params.resources[index][input.name]"
                class="w-100 my-1 rounded"
                @focus.native="e => {setUrlMask(e.target, input.value)}"
                :type="input.type"
                :placeholder="input.required ?
                  input.placeholder + $t('form.required_star') :
                  input.placeholder"
                :required="input.required">
              </b-input>
              <div class="invalid-feedback position-absolute mt-0 text-left" style="bottom: -12px">
                {{$t('errors.error_validation')}}
              </div>
              <i
                v-if="index !== 0"
                @click="deleteWebsite(index)"
                class="fas fa-close fa-lg text-muted position-absolute input-icon"
                style="top: 18px"></i>
            </b-input-group>
          </b-col>
          <b-btn
            v-if="type === 'invitation'"
            variant="link"
            class="mt-1"
            @click="addWebsite"
          >
            <u>{{$t('onboarding.add_a_website')}}</u>
          </b-btn>

        </b-row>

      </b-form>

      <b-col v-if="type === 'registration'" md="12" class="px-3">
        <div v-for="(block, index) in fields.extra" :key="index" class="w-100 mb-2">
          <h6>{{block.title}}</h6>
          <b-form-checkbox
            class="d-block ml-3 mt-1"
            v-for="(option, key) in block.options"
            :key="key"
            v-if="option.type === 'checkbox'"
            :id="`${block.name}-${option.title}`"
            v-model="params.extra[block.name]"
            :value="option.title">
            <div class="d-flex flex-row">
              {{option.title}}
              <b-input
                v-if="option.name === 'other'"
                @focus.native="checkOption(block.name)"
                v-model="other[block.name]"
                style="height: 26px; margin-top: -6px"
                class="ml-2 w-50 p-1 w-100"
              ></b-input>
            </div>
          </b-form-checkbox>
          <div class="px-3" v-else>
            <b-form-textarea
              :id="`${block.name}-textarea`"
              v-model="params.extra[block.name]"
              :rows="3"
              :max-rows="6">
            </b-form-textarea>
          </div>
        </div>
      </b-col>

      <b-btn class="w-100 font-weight-bold p-2 mt-4"
             @click="debounceSubmit">
        {{$t('button.next')}}
      </b-btn>

    </template>
  </onboardingModal>
</template>

<script>
  import {debounce, pull} from 'lodash'
  import onboardingModal from './onboardingModal.vue'
  import fields from './setupFields'

  export default {
    name: "setupStep1",
    components: {
      onboardingModal
    },
    props: {
      email: {
        type: String
      }
    },
    data() {
      return {
        fields: fields,
        formValidated: false,
        params: {
          resources: [
            {
              host: '',
              title: ''
            }
          ],
          extra: {
            sales_software: [],
            mailing_software: [],
            chat_software: [],
            payment_system: [],
            other_services: ""
          }
        },
        other: {
          sales_software: '',
          mailing_software: '',
          chat_software: '',
          payment_system: '',
          other_services: ""
        },
        debounceSubmit: () => {
        }
      }
    },
    created() {
      this.debounceSubmit = debounce(this.submit, 500);

      if (!this.user) {
        this.$router.replace({name: '404'})
      } else {
        this.params.first_name = this.user.first_name;
        this.params.last_name = this.user.last_name;
        this.params.job = this.user.job;
        this.params.company = this.user.company;
        this.params.email = this.user.email;
      }
    },
    computed: {
      type() {
        return this.$route.params.type
      },
      user () {
        return this.$store.getters['auth/user']
      }
    },
    methods: {
      setUrlMask(input, value) {
        if (!input.value && value) {
          input.value = value
        }
      },
      async submit() {
        this.formValidated = true;
        if (this.$refs.form.checkValidity()) {
          try {
            if (this.type === 'registration') {
              await this.addOtherOption()
            }
            const resp = await this.postData('partners/resources', this.params, null, true);
            if (resp && resp.data) {
              await this.$store.dispatch('auth/updateUser', {user: this.params});
              await this.$store.dispatch('resource/setCreatedResources', resp.data.items);
              await this.$store.dispatch('resource/fetchResources');
              await this.$store.dispatch('resource/setDefaultResource');
              await this.$router.push({path: '/setup-step2'})
            }
          } catch (err) {
            console.log(err)
          }
        }
      },
      addOtherOption() {
        return new Promise((resolve) => {
          _.mapKeys(this.other, (value, key) => {
            const i = this.params.extra[key].indexOf('other');
            if (i !== -1) {
              if (!!value) {
                this.params.extra[key][i] = value
              } else {
                pull(this.params.extra[key], 'other')
              }
            }
          });
          resolve()
        })
      },
      checkOption(name) {
        if (this.params.extra[name].indexOf('other') === -1) {
          this.params.extra[name].push( 'other');
        }
      },
      addWebsite() {
        this.addReactiveItemToArray(this.params.resources, {});
        this.$forceUpdate()
      },
      deleteWebsite(index) {
        this.deleteItemByIndex(this.params.resources, index);
        this.$forceUpdate()
      }
    }
  }
</script>
